module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-24.258f847c.svg";